module.exports = __webpack_public_path__ + "media/images/lb/235-37d14becd2dc088450cd24bd793cdf85.svg";